export function getCSRFToken() {
  const csrfMetaElement: HTMLMetaElement | null = document.head.querySelector('[name=csrf-token]');
  return csrfMetaElement?.content ?? null;
}
